<template>
  <div>
    <template>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXABCustomFieldsList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <Loader v-if="isLoading"></Loader>
            <Form v-else
              :handle-submit="onSendForm"
              :initial-values="retrieved"
              :violations="violations"
              @submit="onSendForm($event)"/>
          </b-card>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import Loader from '@/components/Dashboard/Layout/Loader'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Update',
  components: {
    Form,
    Loader
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.retrieve(this.id)
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABCustomFieldsUpdate')
  },
  watch: {
    updated (val) {
      if (val) this.$router.push({ name: 'EXABCustomFieldsList' })
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    ...mapGetters({
      updated: 'customfields/update/updated',
      retrieved: 'customfields/show/retrieved',
      isLoading: 'customfields/show/isLoading',
      violations: 'customfields/update/violations'
    })
  },
  methods: {
    onSendForm (item) {
      // let item = JSON.parse(JSON.stringify(this.retrieved))
      // item.form = JSON.stringify(item.form)
      this.update(item)
    },
    ...mapActions({
      update: 'customfields/update/update',
      retrieve: 'customfields/show/retrieve',
      reset: 'customfields/update/reset'
    })
  }
}
</script>

<style scoped>

</style>
